import React from "react";
import "./FaceGallerySyncStatus.css";

// Face list state shown by both guest face galleries (Swingies / MiniMove), driven by
// useFaceGalleryEngine: a failed /api/faces read keeps the heads on screen with a small "מתעדכן…" chip;
// a genuinely empty event says so instead of showing a blank grid.
export const MSG_SYNCING = "מתעדכן…";
export const MSG_NO_FACES = "אין פנים זמינות כרגע";

export const FaceGallerySyncChip = ({ show }) =>
  show ? (
    <div className="face-gallery-sync-chip rtl" role="status" data-testid="face-gallery-sync">
      {MSG_SYNCING}
    </div>
  ) : null;

export const FaceGalleryEmpty = () => (
  <div className="face-gallery-empty rtl" role="status" data-testid="face-gallery-empty">
    {MSG_NO_FACES}
  </div>
);
